import { Skeleton as MuiSkeleton, SkeletonTypeMap } from '@mui/material';
import { CSSProperties, ReactNode } from 'react';

type SkeletonProps = {
    style?: CSSProperties,
    children: ReactNode;
    loading: boolean;
    variant?: SkeletonTypeMap['props']['variant'];
};

const Skeleton = ({ style, children, loading, variant }: SkeletonProps) => {
    return loading ? <MuiSkeleton style={style} variant={variant ?? 'text'} component={(props: any) => <div {...props} />}>{children}</MuiSkeleton> : <>{children}</>;
};

export default Skeleton;
